import React, { useEffect, useState, useRef } from "react";
import "./Personalize.css";
import Steps from "../Steps";
import personalizeFlow from "./personalize-flow";
import { useHistory } from "react-router-dom";
import api from "../../../app-services/API";
import { useSelector } from "react-redux";
import axios from "axios";
import Base from "./basecharacter";


function Personalizenew(props) {
  const stepref = useRef(null);
  const cardref = useRef(null);

  const {
    alert,
    show,
    editmode,
    editstep = 0,
    data,
    onProceed = () => { },
    closable = false,
    onClose = () => ({}),
    defaultdedication
  } = props;

  const [formStep] = useState(
    [
      { value: 1, label: "Name" },
      { value: 2, label: "Gender" },
      { value: 3, label: "Skin Tone" },
      { value: 4, label: "T-shirt Colour" },
      { value: 5, label: "Hair Style" },
      { value: 6, label: "Hair Colour" },
      { value: 7, label: "Eyewear" },
    ].filter((obj) => {
      if (editmode) {
        return data.value == obj.value;
      } else {
        return true;
      }
    })
  );

  const [questions, setQuestion] = useState(personalizeFlow(formStep));
  const [step, setStep] = useState(editstep);
  const customCharacter = useSelector((state) => state.customCharacter);
  const [steps, setSteps] = useState(customCharacter || []);
  const [charectorStyles, setCharectorStyles] = useState([]);
  const [overlayStyle, setOverlayStyle] = useState({});

  const setAnswer = (obj, i) => {
    let keys = Object.keys(obj);
    let tmpSteps = questions.map((o, ii) => ({
      ...o,
      ...(steps[ii] || {}),
      ...(customCharacter[ii] || {}),
    }));
    tmpSteps[i].ans = obj;
    if (keys.includes("gender")) {
      let hairStyleIndex = tmpSteps.findIndex((o) => o.name == "hair-style");
      tmpSteps[hairStyleIndex] = [];
    }
    let refobj = tmpSteps[i];

    if (["text", "textarea"].includes(refobj.collect && refobj.collect[0]?.type)) {
      clearTimeout(cardref.current && cardref.current.sio);
      cardref.current.sio = setTimeout(() => {
        mixins.setStore(
          "customCharacter",
          tmpSteps.map((temp) =>
            Object.filter(temp, (v, k) => !["collect", "overlay"].includes(k))
          ),
          props
        );

        setSteps(tmpSteps);
      }, 500);
    } else {
      mixins.setStore(
        "customCharacter",
        tmpSteps.map((temp) =>
          Object.filter(temp, (v, k) => !["collect", "overlay"].includes(k))
        ),
        props
      );
      setSteps(tmpSteps);
    }
  };

  useEffect(() => {
    updateStyles();
    updateHairStyle();
  }, [customCharacter]);

  const validateAns = (ques, index) => {
    switch (ques.type) {
      case "option":
        return Boolean(steps[index]?.ans?.value);
      case "image-form":
        if (steps[index]?.ans?.first_name == "" || steps[index]?.ans?.first_name?.length < 3) {
          return false;
        } else {
          if (typeof steps[index]?.ans == "object") {
            return Boolean(
              Object.entries(steps[index]?.ans)
                .map(([key, val]) => val)
                .join("")
            );
          } else {
            return Boolean(steps[index]?.ans);
          }
        }
      case "booklet":
        return true;
      case "finalpage":
        return true;
      default:
        return false;
    }
  };

  const nextStep = (obj, index, finish) => {
    let tmpSteps = [...(steps || [])];
    if (!finish && index + 1 < questions.length) {
      tmpSteps[index] = { ...obj, ...(tmpSteps[index] || {}) };
      setStep(index + 1);
      setSteps(tmpSteps);
    } else {
      mixins.setStore("newbook", tmpSteps, props);
      onProceed(tmpSteps);
      setTimeout(() => {
        const platform = window.navigator.platform;
        let appleSystems = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        if (appleSystems.includes(platform)) {
          window.location.reload(true);
        }
      });
    }
  };

  const prevStep = (index) => {
    if (index === 0) {
      onClose()
    } else {
      setStep((s) => Math.max(0, s - 1));
    }
  };

  const updateStyles = () => {
    let skinStyle = customCharacter.find((o) => o.name == "skin");
    let hairStyle = customCharacter.find((o) => o.name == "hair");
    let tshirtStyle = customCharacter.find((o) => o.name == "tshirt");
    let eyewearStyle = customCharacter.find((o) => o.name == "eyewear");

    setOverlayStyle({
      "--skin":
        (skinStyle && skinStyle.ans && skinStyle.ans.skin) || "transparent",
      "--hair":
        (hairStyle && hairStyle.ans && hairStyle.ans.hair) || "transparent",
      "--shoes": "#ae7928",
      "--shirt":
        (tshirtStyle && tshirtStyle.ans && tshirtStyle.ans.tshirt) ||
        "transparent",
      "--short": "#597aab",
      "--glass":
        eyewearStyle && eyewearStyle.ans && eyewearStyle.ans.eyewear == "yes"
          ? "black"
          : "transparent",
    });
  };

  const updateHairStyle = () => {
    return new Promise((resolve) => {
      let hairStyle = customCharacter.find((o) => o.name == "hair-style");
      if (hairStyle && hairStyle.ans && hairStyle.ans["hair-style"]?.parse) {
        let ans = hairStyle.ans["hair-style"].parse();
        let { gender, style } = ans;
        let imgObj = charectorStyles.find(
          (o) => o.gender == gender && o.style == style
        );
        if (imgObj) {
          let tmpQuestions = questions.map((q) => {
            q.overlay = () => (
              <div
                className="overlay-customcharector"
                dangerouslySetInnerHTML={{ __html: imgObj.imgresponce }}
              ></div>
            );
            return q;
          });
          setQuestion(tmpQuestions);
        }
        resolve(hairStyle);
      } else {
        let imgObj = charectorStyles[1];
        if (imgObj) {
          let tmpQuestions = questions.map((q) => {
            q.overlay = () => (
              <div className="overlay-customcharector">
                <Base />
              </div>
            );
            return q;
          });
          setQuestion(tmpQuestions);
        }
        resolve();
      }
    });
  };

  useEffect(() => {
    updateHairStyle();
  }, [charectorStyles, customCharacter]);

  const getAssets = () => {
    let promiseCharAssets = api.getCharacterAssets();
    let promiseCustomCharImages = api.listCustomCharacterImage();

    Promise.all([promiseCharAssets, promiseCustomCharImages]).then(
      (results) => {
        let res = results[0];
        let assets = {};
        formStep.map((stepItem) => {
          assets[stepItem.label] = res.data
            .filter((o) => o.typeId == stepItem.value)
            .map((o) => {
              o.type = o.assetType.type;
              if (o.type != "Hair Style") {
                o.code = JSON.parse(o.code);
                o.code = `rgb(${o.code.R},${o.code.G},${o.code.B})`;
              }
              return o;
            });
        });

        // Skin tone mapping (questions index might differ depending on personalizeFlow)
        if (questions[3] && assets["Skin Tone"]) {
          questions[3].collect[0].typeName = "Skin Tone";
          const skinRadios = questions[3].collect[0].radios || [];
          questions[3].collect[0].radios = assets["Skin Tone"].map((o, i) => ({
            ...(skinRadios[i] || {}),
            label: (
              <div
                className="skin-tone"
                style={{
                  backgroundColor: o.code,
                  height: "40px",
                  width: "40px",
                  border: "1px solid grey",
                  borderRadius: "50%",
                }}
              ></div>
            ),
            value: o.code,
          }));
        }

        if (questions[6] && assets["Hair Colour"]) {
          questions[6].collect[0].typeName = "Hair Colour";
          const hairColor = questions[6].collect[0].radios || [];
          questions[6].collect[0].radios = assets["Hair Colour"].map(
            (o, i) => ({
              ...(hairColor[i] || {}),
              label: (
                <div
                  className="hair-color"
                  style={{
                    backgroundColor: o.code,
                    height: "40px",
                    width: "40px",
                    border: "1px solid grey",
                    borderRadius: "50%",
                  }}
                ></div>
              ),
              value: o.code,
            })
          );
        }

        if (questions[5] && assets["Hair Style"]) {
          questions[5].collect[0].typeName = "Hair Style";
          const hairStyle = questions[5].collect[0].radios || [];
          questions[5].collect[0].radios = assets["Hair Style"].map((o, i) => ({
            ...(hairStyle[i] || {}),
            label: <img src={o.file.filePath} alt={`hair-${i}`} />,
            value: o.code,
          }));
          questions[5].collect[0].filter = (obj, anslist) => {
            let genderObj = anslist.find((o) => o.name == "gender");
            return obj.value.includes(
              genderObj?.ans?.gender == "boy" ? "boy" : "girl"
            );
          };
        }

        if (questions[4] && assets["T-shirt Colour"]) {
          questions[4].collect[0].typeName = "T-shirt Colour";
          const t_shirt_Color = questions[4].collect[0].radios || [];
          questions[4].collect[0].radios = assets["T-shirt Colour"].map(
            (o, i) => ({
              ...(t_shirt_Color[i] || {}),
              label: (
                <div
                  className="hair-color"
                  style={{
                    backgroundColor: o.code,
                    height: "40px",
                    width: "40px",
                    border: "1px solid grey",
                    borderRadius: "50%",
                  }}
                ></div>
              ),
              value: o.code,
            })
          );
        }

        let customImages = results[1].data || [];
        let customImagesPromises = customImages.map(
          (o) =>
            new Promise((resolve) => {
              axios
                .get(o.filePath)
                .then((res) => resolve({ ...o, imgresponce: res.data }))
                .catch(() => resolve({ ...o, imgresponce: "" }));
            })
        );

        Promise.all(customImagesPromises)
          .then((res) => {
            setCharectorStyles(res);
          })
          .catch((err) => console.log({ err }));
      }
    );
  };

  const goBack = () => {
    onClose();
  };

  useEffect(() => {
    if (show) {
      getAssets();
    }

  }, [show]);

  return (
    <div className="personolize" style={overlayStyle} ref={cardref}>
      {closable === true && (
        <i
          className="close fa fa-times"
          onClick={() => onClose()}
        />
      )}
      {closable === false && (
        <i className="close fa fa-times" onClick={() => goBack()} />
      )}

      <Steps
        ref={stepref}
        questions={questions.filter((o) => !o.hidden)}
        index={step}
        setAnswer={(...arg) => setAnswer(...arg)}
        validateAns={(...arg) => validateAns(...arg)}
        answers={steps}
        nextStep={nextStep}
        prevStep={prevStep}
        editmode={editmode}
        setStep={(i) => setStep(i + 1)}
        closable={closable}
      />
    </div>
  );
}
export default connect(Personalizenew)